module.exports = __webpack_public_path__ + "static/media/gallery_012.7f7788cf.png";